import React from 'react';
import Layout from '../Layout';

const MockHomebot = () => (
  <Layout>
    <div className="mt-16 single-page-container">
      <div className="form-section-single text-center">
        <h1 className="mt-4 mb-2" style={{ color: '#F51E84' }}>Mock Homebot</h1>
        <p className="mb-8" style={{ color: '#ffffff', opacity: 0.9 }}>
          Signup completed against mocked Mikasa and Recurly. No real account or payment was created.
        </p>
      </div>
    </div>
  </Layout>
);

export default MockHomebot;
